import axios from "axios";
import settings from "@/settings";
import _ from 'lodash'
import TimeUtil from '../services/timeUtil'
import moment from "moment"
import { CUSTOMER_DEFAULTS } from "./customerService"
import UtilService from "./util"
import { Snackbar } from "../components/common/Snackbar";

const radiosPath = "radios"
const v1Path = radiosPath + "/v1"
const v2Path = radiosPath + "/v2"

const readsPath = "/reads"
const readsV1Path = radiosPath + '/v1' + readsPath

const aggregateCountsPath   = v1Path + "/aggregatecounts"
const filterValuesPath      = v1Path + "/filtervalues"
const routesSearchPath      = v2Path + "/routes/search"
const downlinkRoutesSearchPath  = v1Path + "/routes/downlink/search"
const buddyOrdSearchPath    = v1Path + "/vitalbuddies/search"
const searchPath            = v2Path + "/search"
const setsPath              = v1Path + "/sets"
const timeSeriesPath        = v2Path + "/timeseries"
const setsCountsPath        = v1Path + "/sets/counts"
const setsUploadPath        = v1Path + "/sets/upload"
const deleteRadiosPath      = v1Path + "/deleteByFile"
const commandsPath          = v1Path + "/commands"
const targetCommandsPath    = v1Path + "/targetCommands/send"
const tuningPath            = v2Path + "/runTuningChain"
const tuningCommsHubPath    = commandsPath + "/configureByFile"
const massDownloadPath      = v1Path + '/download'
const readsSearchPath = readsV1Path + '/search'
const syncRadiosRNIPath = v1Path + '/rniimport'
const channelResultSearchPath = v1Path + "/channelresult/search"
const pingIpPath = v1Path + '/pingip6'
const balanceHysteresisPath = v1Path + "/forcechannelbalance";

const baseUrl = '/api/'
const v1Url = baseUrl + v1Path
const v2Url = baseUrl + v2Path

const aggregateCountsUrl    = baseUrl + aggregateCountsPath
const filterValuesUrl       = baseUrl + filterValuesPath
const routesSearchUrl       = baseUrl + routesSearchPath
const buddyORDSearchUrl     = baseUrl + buddyOrdSearchPath
const searchUrl             = baseUrl + searchPath
const setsUrl               = baseUrl + setsPath
const setsUploadUrl         = baseUrl + setsUploadPath
const timeSeriesUrl         = baseUrl + timeSeriesPath
const setsCountsUrl         = baseUrl + setsCountsPath
const deleteRadiosUrl       = baseUrl + deleteRadiosPath
const sendCommandUrl        = baseUrl + commandsPath
const searchCommandUrl      = baseUrl + commandsPath + "/search"
const targetCommandsUrl     = baseUrl + targetCommandsPath
const tuningdUrl            = baseUrl + tuningPath
const tuningCommsHub        = baseUrl + tuningCommsHubPath
const massDownloadUrl       = baseUrl + massDownloadPath
const downlinkRoutesSearchUrl   = baseUrl + downlinkRoutesSearchPath
const readsSearchUrl = baseUrl + readsSearchPath
const syncRadiosRNIUrl = baseUrl + syncRadiosRNIPath
const currentAndTargetURL = v1Url + "/currentAndTargetValues"
const currentAndTargetTransmitOpModeURL = currentAndTargetURL + "/transmitOperationalMode"
const currentAndTargetReceiveOpModeURL = currentAndTargetURL + "/receiveOperationalMode"
const currentAndTargetStaticRebroadcasterUrl = currentAndTargetURL + "/staticRebroadcaster"
const currentAndTargetVitalBuddyUrl = currentAndTargetURL + "/isVitalBuddy"
const currentAndTargetFrequencyURL = v1Url + "/channels/currentAndTargetValues/frequency"
const currentAndTargetModulationURL = v1Url + "/channels/currentAndTargetValues/modulation"
const channelResultSearchPathURL = baseUrl + channelResultSearchPath
const pingIpUrl = baseUrl + pingIpPath
const tuningTargetsPathUrl = v1Path + "/ncotimeseries"
const tuningCurrentAllocationPathUrl = v1Url + "/ncoPendingCountsLast"
const balanceHysteresisPathUrl = baseUrl + balanceHysteresisPath;
const resetNcoAnalysisDateUrl = baseUrl + v1Path + "/nco/resetAnalysisDate";
const rapidTuneSweepInfoUrl = v1Url + "/rapidtunesweepinfo"

const RADIO_UPLOAD_ACTIONS = {
    createSet: 'createSet',
    deleteRadios: 'deleteRadios',
    tuneCommsHub: 'tuneCommsHub'
}
const BUDDY_ORD = {
    BUDDY: 'buddy',
    ORD: 'ord',
    SR: "static_rebroadcaster"
}
const pagesToFetchInParallel = 5
const arqivaMaxDownlinksRouteDays = 10

export default {
    timeSeriesPath,
    v2Path,
    aggregateCountsUrl,
    filterValuesUrl,
    routesSearchUrl,
    searchUrl,
    setsUrl,
    setsUploadUrl,
    RADIO_UPLOAD_ACTIONS,
    massDownloadUrl,
    BUDDY_ORD,
    searchCommandUrl,
    targetCommandsUrl,
    readsSearchUrl,
    syncRadiosRNIUrl,
    currentAndTargetFrequencyURL,
    currentAndTargetModulationURL,
    currentAndTargetTransmitOpModeURL,
    currentAndTargetReceiveOpModeURL,
    currentAndTargetStaticRebroadcasterUrl,
    currentAndTargetVitalBuddyUrl,
    channelResultSearchPathURL,
    tuningTargetsPathUrl,
    tuningCurrentAllocationPathUrl,
    balanceHysteresisPathUrl,

    getTimeSeriesUrlFor(id, includeGateway = false) {
        return (includeGateway ? baseUrl : '') +
            `${v2Path}/${id}` +
            '/timeseries'
    },

    createRadioPromises(data = {}, pageCount, abortController) {
        let RadioService = this;
        let i;
        let abort = abortController ? abortController : "undefined"
        let promises = [];
        let page = data.page || 1;

        for (i = 0; i < pagesToFetchInParallel; i++) {
            let pageToFetch = page + i;
            // only create radio fetch promises upto the pageCount we are given
            if (pageToFetch <= pageCount) {
                promises.push(
                    RadioService.getRadios({
                        perPage: 100,
                        pageResults: true,
                        ...data,
                        page: pageToFetch
                    }, abort)
                );
            }
        }

        return promises;
    },

    getRadioPages(data = {}, abortController) {
        let RadioService = this;

        return new Promise((resolve, reject) => {

            let time = new Date().getTime();
            let maxTimeToFetchInSeconds = data.maxTimeToFetchInSeconds || 5.0;
            let startingPageNumber = data.page || 1;
            let pageNumber = startingPageNumber;
            let radioPromise = undefined;

            // if the starting page number is 1 or we do not have the pageCount and recordCount,
            // do a fetch with pageResults to get the pagination object
            if (startingPageNumber === 1 || (!data.pageCount && !data.recordCount)) {
                radioPromise = RadioService.getRadios({
                    page: startingPageNumber,
                    perPage: 100,
                    pageResults: true,
                    ...data
                }, abortController);
                // bump up the pageNumber by 1 since we fetched the 1st page
                pageNumber = pageNumber + 1;
            } else {
                // just have a promise return the pageCount and recordCount passed in the data object this will
                // allow us to skip the initial fetch to get the pagination object and make things a touch quicker.
                radioPromise = new Promise( (resolve) => {
                    resolve({
                        records: [],
                        pagination: {
                            pageCount: data.pageCount,
                            recordCount: data.recordCount
                        }
                    });
                });
            }

            // get the 1st startingPageNumber of radios
            radioPromise.then(value => {
                let pagesLeftToFetch = value.pagination.pageCount - startingPageNumber;
                let radios = value.records;

                // get the rest of the pages that have been requested, or the total radios available
                // and make the REST calls serially, not in parallel
                let promise = Array.from({length: pagesLeftToFetch}).reduce(function (acc) {
                    return acc.then(function (res) {
                        let diff = (new Date().getTime() - time) / 1000;
                        if (diff < maxTimeToFetchInSeconds) {
                            let moreRadioPromises = RadioService.createRadioPromises({
                                perPage: 100,
                                pageResults: false,
                                skipRecordCount: true,
                                ...data,
                                page: pageNumber,
                                writeToStorage: false
                            }, value.pagination.pageCount, abortController);

                            pageNumber += pagesToFetchInParallel;

                            return Promise.all(moreRadioPromises).then(function (results) {
                                results.forEach(result => {
                                    res.push(result);
                                })
                                return res;
                            }).catch(error => {
                                return Promise.reject(error);
                            });
                        } else {
                            // if the fetching of radios has taken longer than the
                            // maxTimeToFetchInSeconds, return an empty promise so we can be done
                            return Promise.resolve([])
                                .then(function () {
                                    return res;
                                });
                        }
                    });
                }, Promise.resolve([]));

                promise.then(radioResults => {
                    radioResults.forEach(result => {
                        radios = radios.concat(result);
                    });

                    let lastPageNumber = 0;

                    // if we got any results, calculate the last pageNumber
                    if (radios && radios.length > 0) {
                        lastPageNumber = pageNumber - 1;
                    }

                    resolve({
                        items: radios,
                        lastPageNumber: lastPageNumber,
                        pageCount: value.pagination.pageCount,
                        recordCount: value.pagination.recordCount
                    });
                }).catch(error => {
                    reject(error);
                });

            }).catch(error => {
                if(error.message !== "canceled"){
                   console.error("RadioService.getRadioPages error:", error);
                   reject(error);
                }
            });
        });

    },

    getRadios(data, abortController) {
        data = data || {};
        let signal = abortController ? abortController.signal : undefined
        return axios({
            url: searchUrl,
            method: "POST",
            data: {
                page: 1,
                perPage: 100,
                ...data
            },
            signal: signal
        })
            .then(result => {
                if (data.pageResults) {
                    return result.data;
                } else {
                    return result.data.records;
                }
            })
            .catch(error => {
                if (error.message !== 'canceled')
                {
                    console.error("RadioService.getRadios error:", error.response);
                    return Promise.reject(error.response);
                }
                return Promise.reject(error);
            });
    },

    /**
     * Return the radio or radios that match the given radio id
     * @param radioId - the radio id to lookup
     * @param allMatches - return all matches or just the first match (needed now that devices was combined with radios)
     * @returns {Promise<AxiosResponse<any>>}
     */
    getRadioById(radioId, allMatches=false) {
        let rId = parseInt(radioId)  // Make sure the id is an integer or the server is unhappy
        return axios.get(`${v2Url}/${rId}`).then(result => {
            return allMatches ? result.data.records : result.data.records[0];
        })
        .catch(error => {
            console.error("RadioService.getRadioById error:", error.response);
            return Promise.reject(error.response);
        });
    },

    /**
     * Aggregate by 2 fields.
     * @param by first field
     * @param by2 2nd field
     * @returns {Promise<AxiosResponse<AxiosResponse<AxiosResponse<AxiosResponse<T>>>>>}
     */
    getAggregateCount(by, by2) {
        if (by2 === undefined) {
            return axios
                .get(aggregateCountsUrl + '?aggregate=' + by)
                .then(result => {
                    return result.data.records;
                })
                .catch(error => {
                    console.error("RadioService.getAggregateCount error:", error.response);
                    return Promise.reject(error.response);
                })
        } else {
            return axios
                .get(aggregateCountsUrl + '?aggregate=' + by + '&aggregate2=' + by2)
                .then(result => {
                    return result.data.records;
                })
                .catch(error => {
                    console.error("RadioService.getAggregateCount error:", error.response);
                    return Promise.reject(error.response);
                })
        }
    },

    /***
    getRouteContainsDate ( records, date) {
        if (date === undefined) {
            return true
        } else if (records !== undefined &&  records.values !== undefined) {
            for (var i= 0; i < records[0].values.length; i++) {
                if (records[0].values[i].timestamp === date) {
                    return records[0].values[i];
                }
            }
        }
        return undefined
    },
     ***/

    /**
     * Filters the route history to just the days in the given time frame.
     * Set the high level stats to the daily average over that time frame
     * @param route - full route identifiers and history
     * @param startDate - timestamp in customer timezone of start of time frame
     * @param endDate - timestamp in customer timezone of end of time frame
     * @returns Return the route history used in the given time frame.
     */
    filterRouteForDatesNA (route, startDate, endDate) {
        let routeForDate = undefined
        let tsValuesForDates = []
        let weightedSnr = 0
        let weightedSignalStrength = 0
        let totalSamples = 0
        let routeRetention = CUSTOMER_DEFAULTS.dataRetentionDays.CLIENT_ROUTES

        // If we do not have start and end days - assume we want retention days back through yesterday
        // The data has been aggregated to the customer's timezone day.
        if (startDate === undefined ) {
            startDate = TimeUtil.getNowInCustomerTimezone(true).subtract(routeRetention, 'days').valueOf()
        }

        if (endDate === undefined ) {
            endDate = TimeUtil.getNowInCustomerTimezone(false).endOf('day').subtract(1, 'days').valueOf() // yesterday last full day
        }

        // Get the routes for the given time frame
        if (route !== undefined && route.timeSeries !== undefined && route.timeSeries.values !== undefined) {

            for (const element of route.timeSeries.values)
            {
                // Get only the route history for the dates requested
                let routeDate = TimeUtil.getDateInCustomerTimezone(element.day.displayString).valueOf() // convert string date to milliseconds for comparison

                // If the data is within our range, and we have samples for that data, then save it and perform the calculations
                if ((routeDate >= startDate && routeDate <= endDate) && (element.numSamples > 0))
                {
                    tsValuesForDates.push(element)
                    weightedSnr += (element.average * element.numSamples)
                    weightedSignalStrength += (element.average2 * element.numSamples)
                    totalSamples += element.numSamples
                }
            }

            if (tsValuesForDates.length > 0) {
                routeForDate = _.clone(route);
                if (totalSamples > 0) {
                    // apply average stats if they exist
                    routeForDate.averageSNR =  isNaN(weightedSnr) ? null : weightedSnr/totalSamples
                    routeForDate.averageSignalStrength =   isNaN(weightedSignalStrength) ? null : weightedSignalStrength/totalSamples
                    routeForDate.numTimesUsed = totalSamples/tsValuesForDates.length
                    routeForDate.daysUsed = route.timeSeries.values.length
                } else {
                    routeForDate.averageSNR = null
                    routeForDate.averageSignalStrength = null
                    routeForDate.numTimesUsed = null
                    routeForDate.daysUsed = 0
                }
                routeForDate.timeSeries = tsValuesForDates
            }
        }
        return routeForDate
    },
    /**
     * Filters the route history to just the days in the given time frame.
     * Set the high level stats to the daily average over that time frame
     * @param route - full route identifiers and history
     * @param startDate - timestamp in customer timezone of start of time frame
     * @param endDate - timestamp in customer timezone of end of time frame
     * @returns Return the route history used in the given time frame.
     */
    filterRouteForDatesArqiva (route, startDate, endDate) {
        let routeForDate = undefined
        //let tsValuesForDates = []
        //let weightedSnr = 0
        //let weightedSignalStrength = 0
        //let totalSamples = 0
        let routeRetention = CUSTOMER_DEFAULTS.dataRetentionDays.CLIENT_ROUTES

        // If we do not have start and end days - assume we want retention days back through yesterday
        // The data has been aggregated to the customer's timezone day.
        if (startDate === undefined ) {
            startDate = TimeUtil.getNowInCustomerTimezone(true).subtract(routeRetention, 'days').valueOf()
        }
        let startDateStr = TimeUtil.getDateInCustomerTimezone(startDate).format("YYYY-MM-DD")
        routeForDate = _.clone(route)
        routeForDate.tuningAvgSNR = route.tuningSNRHistory?.[startDateStr]?.averageSNR
        routeForDate.averageSignalStrength = route.tuningSNRHistory?.[startDateStr]?.averageSignalStrength
        routeForDate.numSamples = route.tuningSNRHistory?.[startDateStr]?.useCount
        routeForDate.tuningNoise = (routeForDate.averageSignalStrength != null && routeForDate.tuningAvgSNR != null)
            ? Math.abs(routeForDate.averageSignalStrength - routeForDate.tuningAvgSNR) : null
        routeForDate.daysUsed = route.timeSeries.values.length
        routeForDate.numTimesUsed = route.tuningSNRHistory?.[startDateStr]?.useCount
        return (routeForDate)

        /***
        if (endDate === undefined ) {
            endDate = TimeUtil.getNowInCustomerTimezone(false).endOf('day').subtract(1, 'days').valueOf() // yesterday last full day
        }

        //console.log ("rfda", route)
        for (const element of route.timeSeries.values)
        {
            let routeDate = TimeUtil.getDateInCustomerTimezone(element.day.displayString).valueOf() // convert string date to milliseconds for comparison
            if (routeDate === startDate)
            {
                console.log ("found route for date", element, route)
                routeForDate = _.clone(route)
                weightedSnr += (element.average * element.numSamples)
                weightedSignalStrength += (element.average2 * element.numSamples)
                totalSamples += element.numSamples
                if (totalSamples > 0)
                {
                    // apply average stats if they exist
                    routeForDate.averageSNR = isNaN(weightedSnr) ? null : weightedSnr/totalSamples
                    //routeForDate.averageSignalStrength = isNaN(weightedSignalStrength) ? null : weightedSignalStrength/totalSamples
                    routeForDate.averageSignalStrength = route.tuningSNRHistory?.[element.day.displayString]?.averageSignalStrength
                    routeForDate.numTimesUsed = totalSamples/route.timeSeries.values.length
                    routeForDate.daysUsed = route.timeSeries.values.length
                }
                else
                {
                    routeForDate.averageSNR = null
                    routeForDate.averageSignalStrength = null
                    routeForDate.numTimesUsed = null
                    routeForDate.daysUsed = 0
                }
                //console.log ("route.tsnr", route.tuningSNRHistory)
                const daySNR = route.tuningSNRHistory?.[element.day.displayString]?.averageSNR
                const daySignalStrength = route.tuningSNRHistory?.[element.day.displayString]?.averageSignalStrength
                //console.log ("data", daySNR, daySignalStrength)

                // Check for null or undefined (but use 0)
                if(_.isNil(daySNR) || _.isNil(daySignalStrength)) {
                    return null
                }
                routeForDate.tuningNoise = Math.abs(daySNR - daySignalStrength)
                routeForDate.tuningAvgSNR = route.tuningSNRHistory?.[element.day.displayString]?.averageSNR
                //console.log("found", routeForDate)
                return (routeForDate)
            }
        }
         **/

        // Get the route info from the timeSeries that matches the start and end dates.
        //let routeForDate = _.clone(route)
        /****
        if (totalSamples > 0)
        {
            // apply average stats if they exist
            routeForDate.averageSNR =  isNaN(weightedSnr) ? null : weightedSnr/totalSamples
            routeForDate.averageSignalStrength =   isNaN(weightedSignalStrength) ? null : weightedSignalStrength/totalSamples
            routeForDate.numTimesUsed = totalSamples/tsValuesForDates.length
        }
        else
        {
            routeForDate.averageSNR = null
            routeForDate.averageSignalStrength = null
            routeForDate.numTimesUsed = null
        }
            ***/
        return routeForDate
    },

    getRadioRoutes(radioId) {

        return axios({
            url: routesSearchUrl,
            method: 'POST',
            data: {
                page: 1,
                perPage: 1000,
                filterList: [{
                    fieldName: "repId",
                    fieldType: "VALUES",
                    filterName: "repId",
                    valueOperator: "EQUALS",
                    values: [parseInt(radioId)]
                }]
            }
        }).then(response => {
            return response.data.records
        }).catch(error => {
            console.error('RadioService.getRadioRoutes error:', error.response ? error.response : error)
            return Promise.reject(error.response)
        })
    },

    getRadioDownlinkRoutes(options) {
        let startDate = null, endDate = null;
        let durationObj = options.durationObj
        let radioId = options.id
        if (durationObj.id === 'custom') {
            startDate = TimeUtil.getDateInCustomerTimezone(durationObj.startDateStr).startOf('day').format('YYYY-MM-DDTHH:mm:ss')
            endDate = TimeUtil.getDateInCustomerTimezone(durationObj.endDateStr).endOf('day').format('YYYY-MM-DDTHH:mm:ss')
        } else if (durationObj.id === 'last10Days') {
            startDate = TimeUtil.getNowInCustomerTimezone().subtract(10, 'days').startOf('day').format('YYYY-MM-DDTHH:mm:ss')
            endDate = TimeUtil.getNowInCustomerTimezone().startOf('day').format('YYYY-MM-DDTHH:mm:ss')
        } else if (durationObj.id === 'last1Days') {
            startDate = TimeUtil.getNowInCustomerTimezone().subtract(1, 'days').startOf('day').format('YYYY-MM-DDTHH:mm:ss')
            endDate = TimeUtil.getNowInCustomerTimezone().startOf('day').format('YYYY-MM-DDTHH:mm:ss')
        }
        if (durationObj.id !== 'custom' && options.includeToday ) {
            endDate = TimeUtil.getNowInCustomerTimezone(true).endOf('day').format('YYYY-MM-DDTHH:mm:ss')
        }
        return axios({
            url: downlinkRoutesSearchUrl,
            method: 'POST',
            data: {
                page: 1,
                perPage: 1000,
                filterList: [{
                    fieldName: "repId",
                    fieldType: "VALUES",
                    filterName: "repId",
                    valueOperator: "EQUALS",
                    values: [parseInt(radioId)]
                },
                {
                    filterName: "lastUsed.displayString",
                    fieldName: "lastUsed.displayString",
                    hasValues: true,
                    fieldType: "RANGE",
                    values: {
                        minValue: startDate,
                        maxValue: endDate
                    }
                }]
            }
        }).then(response => {
            return response.data.records
        }).catch(error => {
            console.error('RadioService.getRadioDownlinkRoutes error:', error.response ? error.response : error)
            return Promise.reject(error.response)
        })
    },

    getRadioRoutesByDestIds(repId) {
        return axios({
            url: routesSearchUrl,
            method: 'POST',
            data: {
                page: 1,
                perPage: 1000,
                filterList: [{
                    fieldName: "destId",
                    fieldType: "VALUES",
                    filterName: "destId",
                    valueOperator: "EQUALS",
                    values: [parseInt(repId)]
                }]
            }
        }).then(response => {
            return response.data.records
        }).catch(error => {
            console.error('RadioService.getRadioRoutesByDestIds error:', error.response ? error.response : error)
            return Promise.reject(error.response)
        })
    },

    buddyOrdFetchOptions(repId, filterName) {
        return axios({
            url: buddyORDSearchUrl,
            method: 'POST',
            data: {
                page: 1,
                perPage: 100,
                filterList: [{
                    fieldName: filterName,
                    fieldType: "VALUES",
                    filterName: filterName,
                    valueOperator: "EQUALS",
                    values: [parseInt(repId)]
                }]
            }
        }).then(response => {
            return response.data.records
        }).catch(error => {
            console.error('RadioService.buddyOrdFetchOptions error:', error.response ? error.response : error)
            return Promise.reject(error.response)
        })
    },
    resetBalanceHysteresis(dest) {
        return axios({
            url: balanceHysteresisPathUrl,
            method: 'POST',
            data: {
                ...dest
            }
        }).then(response => {
            return response.data.records
        }).catch(error => {
            console.error('RadioService.resetChanelBalanceHysteresis error:', error.response ? error.response : error)
            return Promise.reject(error.response)
        })
    },
    resetNcoAnalysisDate(data) {
        return axios({
            url: resetNcoAnalysisDateUrl,
            method: 'POST',
            data: {
                ...data
            }
        }).then(response => {
            return response.data
        }).catch(error => {
            console.error('RadioService.resetNcoAnalysisDate error:', error.response ? error.response : error)
            return Promise.reject(error.response)
        })
    },
    getRadioRouteCounts(groupBy) {
        return this.getAggregateCount(groupBy).then(records => {
            let modifiedRecords = [
                {value: '0', count: 0},
                {value: '1', count: 0},
                {value: '>1', count: 0}
            ]

            records.forEach(rec => {
                if (rec.value === null)
                {
                    ;  // NOSONAR
                }
                else if (rec.value === 0){
                    modifiedRecords[0].count += rec.count
                } else if (rec.value === 1) {
                    modifiedRecords[1].count += rec.count
                } else {
                    modifiedRecords[2].count += rec.count
                }
            })
            return modifiedRecords
        }).catch(error => {
            console.error('RadioService.getRadioRouteCounts error:', error.response ? error.response : error)
            return Promise.reject(error.response)
        })
    },
    getBestTuningUplinkCount(towerId, arqiva) {
        let filterList=[{
            filterName: arqiva ? "radio.tuningBestUplinkTower.baseStationId" : "radio.bestTowerHeard",
            fieldName: arqiva ? "tuningBestUplinkTower.baseStationId": "bestTowerHeard",
            fieldType: "VALUES",
            valueOperator: "EQUALS",
            values: [parseInt(towerId)]
        }]
        return axios({
            url: searchUrl,
            method: "POST",
            data: {
                page: 1,
                perPage: 100,
                countOnly: true,
                filterList: filterList
            }
        }).then(result => {
            return result.data.pagination.recordCount
        }).catch(error => {
            console.error("RadioService.getBestTuningUplinkCount error:", error.response ? error.response : error);
            return Promise.reject(error.response);
        })
    },

    getRadioSingleRoutesCountForTower(towerId) {
        let filterList = [{
            filterName: "towersHeard",
            fieldName: "towersHeard",
            fieldType: "VALUES",
            valueOperator: "EQUALS",
            values: [parseInt(towerId)]
            },
            {
                filterName: "routeCount",
                fieldName: "routeCount",
                fieldType: "VALUES",
                valueOperator: "EQUALS",
                values: [1]
            },
            {
                fieldName: "device.channel",
                fieldType: "VALUES",
                valueOperator: "EQUALS",
                values: [0]
            }
        ]

        return axios({
            url: searchUrl,
            method: "POST",
            data: {
                page: 1,
                perPage: 100,
                countOnly: true,
                filterList: filterList
            }
        }).then(result => {
            return result.data.pagination.recordCount
        }).catch(error => {
            console.error("RadioService.getRadioSingleRoutesForTower error:", error.response ? error.response : error);
            return Promise.reject(error.response);
        })
    },

    deleteRadiosFromFile (formData) {
        let config = { headers: { 'Content-Type': 'multipart/form-data' } };
        return axios.post(deleteRadiosUrl, formData, config).then(result => {
            return result.data
        }).catch(error => {
            console.error('RadioService error in deleteRadiosFromFile:', error.response ? error.response : error)
            return Promise.reject(error.response)
        })
    },

    getRadioAllRoutesCountForTower(towerId) {
        let filterList = [{
            filterName: "towersHeard",
            fieldName: "towersHeard",
            fieldType: "VALUES",
            valueOperator: "EQUALS",
            values: [parseInt(towerId)]
        },
        {
            fieldName: "device.channel",
            fieldType: "VALUES",
            valueOperator: "EQUALS",
            values: [0]
        }
        ]

        return axios({
            url: searchUrl,
            method: "POST",
            data: {
                page: 1,
                perPage: 100,
                countOnly: true,
                filterList: filterList
            }
        }).then(result => {
            return result.data.pagination.recordCount
        }).catch(error => {
            console.error("RadioService.getRadioAllRoutesCountForTower error:", error.response ? error.response : error);
        return Promise.reject(error.response);
    })
    },
    getFilterValues(filterValuesArray) {
        return axios({
            url: filterValuesUrl,
            method: 'POST',
            data: filterValuesArray
        }).then(response => {
            return response.data
        }).catch(error => {
            console.error('RadioService.getFilterValues error:', error.response ? error.response : error)
            return Promise.reject(error)
        })
    },
    getSetsCount() {
        return axios({
            url: setsCountsUrl,
            method: 'get',
        }).then(response => {
            return response.data
        }).catch(error => {
            console.error('RadioService.getSetsCount error:', error.response ? error.response : error)
        })
    },
    /***
    getRadiosForSetByName(name, data) {
        let filterList = [{
            filterName: "sets",
            fieldName: "sets",
            fieldType: "VALUES",
            valueOperator: "EQUALS",
            values: [name]
        }]

        return axios({
            url: searchUrl,
            method: "POST",
            data: {
                page: 1,
                perPage: 100,
                filterList: filterList,
                ...data
            }
        }).then(response => {
            return response.data
        }).catch(error => {
            console.error('RadiosService.getRadiosForSetByName error:', error.response ? error.response : error)
        })
    },
     ***/

    sendPingIP6(repId) {
        return axios({
            url: pingIpUrl + '/' + repId,
            method: 'GET',
        }).then(response => {
            return response.data
        }).catch(error => {
            console.error('RadioService.sendPingIP6 error:', error.response ? error.response : error)
            return Promise.reject(error);
        })
    },

    sendCommand(commandType, radioIdList, configObj) {
        let postData = []
        radioIdList.forEach(radioId => {
            postData.push({commandType: commandType, targetId: parseInt (radioId), targetFields: configObj})
        })
        return axios({
            url: sendCommandUrl,
            method: 'post',
            data: postData
        }).then(response => {
            return response.data
        }).catch(error => {
            console.error('RadioService.sendCommand error:', error.response ? error.response : error)
            return Promise.reject(error);
        })
    },

    /**
     * Wrapper method for sendCommmand that handles notifications in a common place
     * @param context - vue context to access i18n and notifier
     * @param radioIds - array of radio ids to send the command to
     * @param pingCommandServerStr - server string for the command to be sent down to the server
     * @param pingCommandClientStr - client string to display in the notification
     */
    sendPing(context, radioIds, pingCommandServerStr, pingCommandClientStr)
    {
        this.sendCommand(pingCommandServerStr, radioIds).then (results =>
        {
            let baseMsg = context.$t ('radio.pingBaseMsg', {pingType: pingCommandClientStr})
            let warnMsgs = UtilService.checkForWarningMessage (results)
            let notificationObj = {timeout: 10000}
            notificationObj.msgs = warnMsgs ? warnMsgs : [baseMsg, context.$t ('radio.pingBaseMsg2')]
            if (radioIds.length > 1)
            {
                notificationObj.href = '/netmet/history'
                notificationObj.linkText = context.$t ('common.history')
            }
            else
            {
                notificationObj.href = '/netmet/radio/' + radioIds[0] + '/history'
                notificationObj.linkText = context.$t ('radio.radio') + ' ' + radioIds[0] + ' ' + context.$t ('common.history')
            }
            Snackbar().show(notificationObj);
        }).catch(error => {
            Snackbar().show({msg: context.$t('radio.pingSentErrorMsg',{pingType: pingCommandServerStr}),color: 'error', timeout: 10000});
        })
    },

    sendTargetCommands(dest) {
        let postData = {}
        if (_.isArray(dest)) {
            postData.repIdList = dest.map(id => parseInt(id))
        } else if (_.isString(dest)) {
            postData.setName = dest
        }
        return axios({
            url: targetCommandsUrl,
            method: 'POST',
            data: {
                ...postData
            }
        }).then(response => {
            return response.data
        }).catch(error => {
            console.error('RadioService.sendTargetCommands error:', error.response ? error.response : error)
            return Promise.reject(error);
        })
    },

    tuneRadios(items) {
        let postData = {jobsToRun: ["ALL_JOBS"]}

        if (items.repIds) {
            postData.repIds = items.repIds.map(id => parseInt(id))
        }

        if (items.uplinkTuningBestBaseStationId) {
            postData.uplinkTuningBestBaseStationId = parseInt(items.uplinkTuningBestBaseStationId)
        }

        return axios({
            url: tuningdUrl,
            method: 'post',
            data: postData
        }).then(response => {
            return response.data
        }).catch(error => {
            console.error('RadioService.tuneRadios error:', error.response ? error.response : error)
            return Promise.reject(error);
        })
    },
    tuneCommsHubFromFile(formData) {
        let config = { headers: { 'Content-Type': 'multipart/form-data' } };
        return axios.post(tuningCommsHub, formData, config).then(result => {
            return result.data
        }).catch(error => {
            console.error('RadioService error in tuneCommsHubViaUpload: ', error.response ? error.response : error)
            return Promise.reject(error.response)
        })
    },
    // merge route objects and buddies/ords object depending upon the endpoints destination type
    mergeRoutesAndVitalBuddies(promiseArrResult, destType) {
        if (destType && promiseArrResult && promiseArrResult.length > 1) {
            let routes = promiseArrResult[0]
            let vitalBuddies = promiseArrResult[1]
            // these props are the merge conditions for routes records and vital buddy/ord records
            let prop1 = '', prop2 = ''
            if (destType === 'ord') {
                prop1 = 'destId'; prop2 = 'buddyRepId'
            } else if(destType === 'buddy') {
                prop1 = 'repId'; prop2 = 'ordRepId'
            }
            // merging the records routes and buddies/ord 
            let mergedRoutes = routes.map(route => ({
                ...route,
                ...vitalBuddies.find((item) => (item[prop2] === route[prop1]) && item)
            }));
            return mergedRoutes
        } else {
            if (promiseArrResult[0] && promiseArrResult[0].length) {
                return promiseArrResult[0]
            } else if(promiseArrResult[1] && promiseArrResult[1].length) {
                 return promiseArrResult[1]
            } 
            return []
        }
    },
    getRadioDestType(radioObj) {
        let destType = ''
        if (radioObj)
        {
            if ((radioObj.tuning.isORD) || (radioObj.buddySupportState && radioObj.buddySupportState.toLowerCase () === BUDDY_ORD.ORD))
            {
                destType = BUDDY_ORD.ORD
            }
            else if (radioObj.buddySupportState && (radioObj.buddySupportState.toLowerCase () === BUDDY_ORD.BUDDY || radioObj.buddySupportState.toLowerCase () === BUDDY_ORD.SR))
            {
                destType = BUDDY_ORD.BUDDY
            }
        }
        return destType
    },
    getRadiosFieldsByIds(ids) {
        if(ids.length) {
            let filterList = [{
                filterName: "radio.repId",
                fieldName: "repId",
                fieldType: "VALUES",
                valueOperator: "EQUALS",
                values: [...ids],
            },
            {
                fieldName: "device.channel",
                fieldType: "VALUES",
                valueOperator: "EQUALS",
                values: [0]
            }]
            return axios({
                url: searchUrl,
                method: "POST",
                data: {
                    page: 1,
                    perPage: 100,
                    filterList: filterList
                }
            }).then(response => {
                return response.data.records
            }).catch(error => {
                console.error('RadiosService.getRadiosForSetByName error:', error.response ? error.response : error)
            })
        }
    },
    getRoutePurgeDateString (context)
    {
        let sprPurgeOffset = parseInt(settings.purgeSPRRouteFieldsDays) ? parseInt(settings.purgeSPRRouteFieldsDays) : 10
        let sprPurgeDateStr = moment().subtract(sprPurgeOffset,'d').toISOString()
        return (TimeUtil.shortDateFormatter(sprPurgeDateStr))
    },

    cancelCommand (radioId, commandType)
    {
        return axios({
            url: sendCommandUrl+'/cancel/'+radioId+"/"+commandType,
            method: 'delete',
        }).then(response => {
            return response.data
        }).catch(error => {
            console.error('RadioService.cancelCommand error:', error.response ? error.response : error)
            return Promise.reject(error);
        })
    },

    getGlobalCommandSetting ()
    {
        return axios({
            url: sendCommandUrl+'/status',
            method: 'get',
        }).then(response => {
            return response.data
        }).catch(error => {
            console.error('RadioService.getGlobalCommandStatus error:', error.response ? error.response : error)
            return Promise.reject(error);
        })
    },    
    rniRadiosSync (userInput)
    {
        return axios({
            url: syncRadiosRNIUrl,
            method: 'put',
            params: {
                forceAll: userInput
            }
        }).then().catch(error => {
            console.error('RadioService.syncRadiosFromRNI error:', error.response ? error.response : error)
            return Promise.reject(error);
        })
    },
    setGlobalCommandSetting (enableSetting)
    {
        return axios({
            url: sendCommandUrl+'/status?enabled='+enableSetting,
            method: 'put',
        }).then(response => {
            return response.data
        }).catch(error => {
            console.error('RadioService.changeGlobalCommandSetting error:', error.response ? error.response : error)
            return Promise.reject(error);
        })
    },
    getChannelBalanceResultHistory(context) {
        // get the list in descending order, so that last run will be on top always
        let sortByList = {sortByList: [{ fieldName: "channelBalanceResultCreateTime.displayString", direction: "Descending"}]}
        return axios.post(channelResultSearchPathURL, {page: 1, perPage: 1000,...sortByList}).then (results => {
            let timeList = []
            let firstItemStartTime = ''
            if (results && results.data && results.data.records)
            {
                firstItemStartTime = new Date(results.data.records[0]?.channelBalanceResultCreateTime?.epoch)
                timeList = results.data.records.map(item =>
                {
                    if (item.channelBalanceResultCreateTime)
                    {
                        return ({
                            id: item.channelBalanceResultHistoryId,
                            value: item.channelBalanceResultHistoryId,
                            firstItemStartTime: firstItemStartTime,
                            name: item.channelBalanceResultCreateTime.uiDisplayString
                        })
                    }
                })
            }
            return timeList
        }).catch(error => {
            console.error('RadioService error in getChannelBalanceResultHistory:', error.response ? error.response : error)
            return []
        })
    },
    getSets() {
        return axios({
            url: filterValuesUrl,
            method: 'POST',
            data: ['sets']
        }).then(result => {
            return result.data.records.length ? result.data.records[0].values : []
        }).catch(error => {
            console.error('RadioService.getSets error:', error.response ? error.response : error)
            return Promise.reject(error);
        })  
    },
    getRapidTuneSweepInfo()
    {
        return axios({url: rapidTuneSweepInfoUrl, method: 'GET',}).then(result => {
            return result.data.records[0]
        }).catch(error =>
        {
            console.error('RadioService.getRapidTuneSweepInfo error:', error.response ? error.response : error)
            return Promise.reject(error);
        })
    }
}
